module.exports = __webpack_public_path__ + "static/assets/c5be883427400df62050a9fcd14a21ff.svg";